import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/sales/customers/";

export function getCustomers() {
  return http.get(apiEndpoint);
}

export function getCustomer(customerID) {
  return http.get(apiEndpoint + "customer-detail/" + customerID);
}

export function getCustomerMasterDataAPI() {
  return http.get(apiEndpoint + "customer-master-data");
}

export function saveCustomer(customer) {
  if (customer.ID === 0) {
    return http.post(apiEndpoint, customer);
  } else {
    return http.put(apiEndpoint, customer);
  }
}

export function saveCustomerAddress(address) {
  return http.post(apiEndpoint + "customer-address", address);
}

export function deleteCustomerAddress(addressID) {
  return http.delete(apiEndpoint + "customer-address/" + addressID);
}

export function getCustomerAddress(customerID) {
  return http.get(apiEndpoint + "customer-address/" + customerID);
}

export function saveCustomerContact(contact) {
  return http.post(apiEndpoint + "customer-contact", contact);
}

export function deleteCustomerContact(contactID) {
  return http.delete(apiEndpoint + "customer-contact/" + contactID);
}

export function getCustomerContact(customerID) {
  return http.get(apiEndpoint + "customer-contact/" + customerID);
}

export function getCustomerContactAccount(contactID) {
  return http.get(apiEndpoint + "customer-contact-account/" + contactID);
}

export function getCustomerContacts() {
  return http.get(apiEndpoint + "customer-contacts");
}

export function generateSendCustomerPortalAccess(contact) {
  return http.post(
    apiEndpoint + "generate-send-customer-portal-access",
    contact
  );
}

export function deleteCustomer(customerID) {
  return http.delete(apiEndpoint + customerID);
}

export function restoreCustomer(customerID) {
  return http.put(apiEndpoint + customerID);
}

export function getCustomerInvoices(customerID) {
  return http.get(apiEndpoint + "customer-invoices/" + customerID);
}

export function getCustomerPayments(customerID) {
  return http.get(apiEndpoint + "customer-payments/" + customerID);
}

export function getCustomerQuotations(customerID) {
  return http.get(apiEndpoint + "customer-quotations/" + customerID);
}

export function getCustomerSalesOrders(customerID) {
  return http.get(apiEndpoint + "customer-sales-orders/" + customerID);
}

export function getCustomerPendingGI(customerID) {
  return http.get(apiEndpoint + "customer-pending-gi/" + customerID);
}
